// path: frontend/src/utils/entityAuthor.jsx
/**
 * Сборка подзаголовка модалки: реквизиты автора сущности (задачи или
 * проекта). Единая точка правды для TaskModal и ProjectModal:
 * разметка идентична, отличается только подпись («Задачу составил» /
 * «Проект составил»).
 *
 * Возвращает массив React-узлов для subtitle-пропа ModalShell → Modal
 * (тот рендерит {subtitle} внутри .modal-subtitle), либо null, если
 * автора нет или у него не заполнено ни одно из полей. Пустой массив
 * не возвращаем: Modal при falsy subtitle не рендерит блок вовсе -
 * null здесь честнее, чем [], и совпадает с исходным поведением
 * TaskModal.
 *
 * fallbackDomain — домен для legacy-email без @ (когда email хранился
 * как логин). Сейчас EmployeeApiDto.email всегда полный, так что
 * fallback — защита от старых записей в БД. Источник — meta
 * (allowedEmailDomains[0]), передаётся вызывающим (useAuthorFallbackDomain).
 * Раньше здесь был импорт DOMAIN из constants.js — убрано (deprecated).
 */

const stopPropagation = (e) => e.stopPropagation();

export function buildAuthorSubtitle({
  creatorId,
  employees,
  label,
  fallbackDomain = "",
  emailSubject,
}) {
  if (!creatorId || !Array.isArray(employees)) return null;

  const author = employees.find((e) => e.id === creatorId);
  if (!author) return null;

  const nodes = [];

  const name = [author.last, author.first].filter(Boolean).join(" ").trim();
  if (name) {
    nodes.push(
      <span key="author">
        {label}: <b>{name}</b>
      </span>,
    );
  }

  if (author.extension) {
    nodes.push(
      <span key="ext">
        вн. тел.: <b>{author.extension}</b>
      </span>,
    );
  }

  if (author.email) {
    const rawEmail = String(author.email).trim();
    const email = rawEmail.includes("@")
      ? rawEmail
      : fallbackDomain
        ? `${rawEmail}@${fallbackDomain}`
        : rawEmail;

    const mailtoHref = emailSubject
      ? `mailto:${email}?subject=${encodeURIComponent(emailSubject)}`
      : `mailto:${email}`;

    nodes.push(
      <span key="email">
        e-mail:{" "}
        <a href={mailtoHref} onClick={stopPropagation}>
          {email}
        </a>
      </span>,
    );
  }

  if (nodes.length === 0) return null;

  const result = [];
  nodes.forEach((node, i) => {
    if (i > 0) result.push(" | ");
    result.push(node);
  });
  return result;
}
